import { axiosInstance } from '@fides/fides-react-components';
import { AxiosError } from 'axios';
import { CreditTransferOrder } from '../models';
import { JsonObject } from '../types';
import { endpoints } from '../consts';

export const orderAction = (action: string, uniqueIds: CreditTransferOrder['uniqueId'][], code = ''): Promise<void> =>
  axiosInstance
    .post(
      `${endpoints.orders}/${action}`,
      action === 'sign'
        ? {
            uuids: [...uniqueIds],
            securityCode: code,
          }
        : [...uniqueIds],
      { baseURL: endpoints.EFTApiUrl }
    )
    .then(() => Promise.resolve())
    .catch((error: AxiosError<JsonObject>) => Promise.reject(error));
